import Stack from "@mui/material/Stack";
import TextField from "@mui/material/TextField";
import React, { useEffect } from "react";
import ColourField from "../common/colour.field";
import { useForm } from "../common/form.util";
import SubjectSelect from "../subject/subject.select";
import { Autocomplete } from "@mui/material";
import { courseApi } from "./course.queries";

export default function CourseForm(props) {
	const formCtx = useForm(props.course, props);
	let course = formCtx?.data;

	const useGetGrades = courseApi.useGetGrades();
	let grades = useGetGrades?.data;

	useEffect(() => {
		formCtx.setData(props.course);
	}, [props.course]);

	const onSubjectChange = (subject) => {
		course.subject = subject;
		course.subjectId = subject.id
		formCtx.onChange(subject.id, 'subjectId');
	}

	return (
		<Stack direction="column">
			<SubjectSelect value={course?.subjectId || ''} onChange={(e, subject) => onSubjectChange(subject)} required autoFocus />
			<TextField label="Course" variant="standard" value={course?.name || ''} onChange={(e) => formCtx.onChange(e, 'name')} required />
			<Autocomplete freeSolo resetHighlightOnMouseLeave options={grades} value={course?.grade || ''} onChange={(e, newValue) => formCtx.onChange(newValue, 'grade')} renderInput={(params) => <TextField {...params} label="Grade" variant="standard" onChange={(e) => formCtx.onChange(e, 'grade')} required />} />
			{!props.required &&
				<React.Fragment>
					<TextField label="Description" variant="standard" value={course?.description || ''} onChange={(e) => formCtx.onChange(e, 'description')} multiline />
					<ColourField label="Colour" variant="standard" value={course?.colour || course?.subject?.colour || ''} onChange={(e) => formCtx.onChange(e, 'colour')} />
					{/* <TextField label="Icon" variant="standard" value={course?.icon || ''} onChange={(e) => formCtx.onChange(e, 'icon')} /> */}
				</React.Fragment>
			}
		</Stack>
	);
}